import { safeSessionStorage } from '@toss/storage';

import {
  createPlanAlertStorage,
  defaultStorageAdapter,
  type StorageAdapter,
} from './createPlanAlertStorage';

interface TrialEndDiscountAlertState {
  /** 모달을 보여준 windowEnd. 할인 창이 새로 열리면 값이 달라져 다시 뜬다. */
  modalShownFor?: string;
  /** "할인 종료" 배너를 이미 닫은 windowEnd(영구). */
  endedClosedFor?: string;
}

const SESSION_DISMISS_KEY = 'trial-end-discount-banner-dismissed';

/**
 * 체험 종료 할인 노출 상태 (PRD 솔루션 6).
 *
 * 모달은 windowEnd 당 1회(localStorage), 배너 X 는 세션 동안만 숨김(sessionStorage),
 * 단 "할인 종료" 상태의 X 는 영구 제거다(Figma 29139:3344 주석).
 */
export function createTrialEndDiscountStorage(
  storage: StorageAdapter = defaultStorageAdapter,
) {
  const alertStorage = createPlanAlertStorage<TrialEndDiscountAlertState>(
    'trial-end-discount-alert',
    storage,
  );

  return {
    shouldShowModal(windowEnd: string): boolean {
      return (
        alertStorage.getState().modalShownFor !== `post-expiry:${windowEnd}`
      );
    },
    markModalShown(windowEnd: string): void {
      alertStorage.setState({
        ...alertStorage.getState(),
        modalShownFor: `post-expiry:${windowEnd}`,
      });
    },
    isEndedClosed(windowEnd: string): boolean {
      return alertStorage.getState().endedClosedFor === windowEnd;
    },
    markEndedClosed(windowEnd: string): void {
      alertStorage.setState({
        ...alertStorage.getState(),
        endedClosedFor: windowEnd,
      });
    },
    isBannerDismissed(windowEnd: string): boolean {
      try {
        return (
          safeSessionStorage.get(SESSION_DISMISS_KEY) ===
          `post-expiry:${windowEnd}`
        );
      } catch {
        return false;
      }
    },
    dismissBanner(windowEnd: string): void {
      try {
        safeSessionStorage.set(SESSION_DISMISS_KEY, `post-expiry:${windowEnd}`);
      } catch {
        // storage 오류 무시
      }
    },
    reset(): void {
      alertStorage.reset();
    },
  };
}

/** 싱글톤 인스턴스 */
export const trialEndDiscountStorage = createTrialEndDiscountStorage();
